




































import { Component, Vue } from 'vue-property-decorator'
import { State, namespace } from 'vuex-class'
import moment from 'moment'
import HashTip from '@/components/HashTip.vue'

@Component({
  components: {
    HashTip,
  },
})
export default class Blocks extends Vue {
  @State('bp') bpState
  @namespace('bp').Getter latestHeight
  @namespace('bp').Getter landingBlocks

  // table columns definition
  private columns = [
    {
      title: '块高',
      dataIndex: 'height',
      scopedSlots: { customRender: 'height' },
    },
    {
      title: '交易数',
      dataIndex: 'tx_count',
    },
    {
      title: '哈希',
      dataIndex: 'hash',
      scopedSlots: { customRender: 'toHash' },
    },
    {
      title: '生产者',
      dataIndex: 'producer',
      scopedSlots: { customRender: 'cutHash' },
    },
    {
      title: '默克尔树根',
      dataIndex: 'merkle_root',
      scopedSlots: { customRender: 'cutHash' },
    },
    {
      title: '父节点',
      dataIndex: 'parent',
      scopedSlots: { customRender: 'cutHash' },
    },
    {
      title: '时间',
      dataIndex: 'timestamp_human',
      scopedSlots: { customRender: 'date' },
    },
  ]

  data = []
  pagination = {
    total: 0,
    pageSize: 16,
    page: 1,
    current: 1,
  }
  loading = false

  // lifecycle hook
  mounted() {
    this.$store.dispatch('bp/connectBP').then(() => this.fetchData(1))
  }

  handleTableChange(pagination: any) {
    console.log(pagination)
    const current: number = pagination.current
    this.pagination.current = current
    this.fetchData(current)
  }

  // methods
  formatDate(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  }

  // async
  async fetchData(page = this.pagination.current) {
    this.loading = true
    try {
      let result = await this.$store.dispatch('bp/getBlocks', {
        page: page,
        size: this.pagination.pageSize,
      })
      this.data = result.blocks
      this.pagination.total = result.pagination.total
      this.loading = false
    } catch (error) {
      console.error(error)
    }
  }
}
